<template>
	<page>
		<module enable-flex>
			<m-search ref="search" @search="searchHandle">
				<c-form ref="searchForm">
					<c-form-item type="input" label="用户名" name="login_name"></c-form-item>
					<c-form-item type="input" label="昵称" name="nick_name"></c-form-item>
					<c-form-item type="input" label="手机号" name="user_manage_mobilephone"></c-form-item>
					<c-form-item type="checkbox" label="用户状态" name="state" :options="stateType"></c-form-item>
				</c-form>
			</m-search>
			<c-table ref="table" >
				<!-- <c-table-column
					type="selector"
				></c-table-column> -->

				<c-table-column
					label="审批状态"
					name="state"
					width="90"
				>
					<template v-slot="{data}">
						<span v-if="data.state == 3" style="color:blue;">待审批</span>
						<span v-if="data.state == 4" style="color:red">驳回</span>
					</template>
				</c-table-column>

				<c-table-column
					label="用户名"
					name="login_name"
					width="110"
				>
				</c-table-column>

				<c-table-column
					label="手机号"
					name="user_manage_mobilephone"
					width="120"
				>
				</c-table-column>
				
				

				<c-table-column
					label="昵称"
					name="nick_name"
					width="150"
				>
					<template v-slot="{data}">
						<span v-if="data.nick_name && data.nick_name!=''">{{data.nick_name}}</span>
						<span v-else>--</span>
					</template>
				</c-table-column>

				<c-table-column
					label="业务推荐码"
					name="salesman_code"
					width="150"
				>
					<template v-slot="{data}">
						<span v-if="data.salesman_code && data.salesman_code!=''">{{data.salesman_code}}</span>
						<span v-else>--</span>
					</template>
				</c-table-column>

				<c-table-column
					label="注册时间"
					name="create_date"
					width="140"
				>
				</c-table-column>

				<c-table-column
					label="注册来源"
					name="user_resource"
					width="80"
				>
					<template v-slot="{data}">
						{{userResourceMap[data.user_resource]}}
					</template>
				</c-table-column>

				<c-table-column
					type="button"
					fixed="right"
					label="操作"
					width="80"
				>
					<template v-slot="{data}">
						<c-table-button v-if="data.state == 3" @click="detail(data)">审批</c-table-button>
						<c-table-button v-else @click="detail(data)">详情</c-table-button>
					</template>
				</c-table-column>
			</c-table>
		</module>
	</page>
</template>

<script>
	import {mapState} from 'vuex'
	export default {
		name: 'm_platform_user_apply',

		props: {
		    state: String
		},

		data() {
			return {
				editState: false,   //编辑或是新增  true=编辑  false=新增
				userResourceMap: {
					'OMS':'管理后台',
					'PC':'PC电脑',
					'IOS':'苹果APP',
					'ANDROID':'安卓APP',
					'MINI':'微信小程序',
					'BARGAIN':'砍价页',
					'H5':'H5页'
				},
				stateType:[
					{
						name:'待审批',
						value:3
					},{
						name:'已驳回',
						value:4
					}
				]
			}
		},
		computed: {
			...mapState(['systemConfig']),
			defaultSearch() {
			    let param = {
			        state: this.state ? this.state.split(',') : [],
			    }
			
			    return param;
			}
		},
		watch: {
		    defaultSearch(val) {
		        this.$refs.searchForm.set(val);
		        this.$nextTick(() => {
		            this.$refs.search.search();
		        })
		    }
		},
		mounted() {
			this.$refs.searchForm.set(this.defaultSearch);
			this.$nextTick(() => {
			    this.$refs.search.search();
			})
			
			this.$bus.$on('platformApplyList.update', () => {
			    this.$refs.search.search();
			});
		},

		methods: {
			searchHandle(data) {
				data.query_type = 2;
				this.$refs.table.load({
					url: '/platform_user/list',
					data
				});
			},
			detail(val) {
				this.navigateTo({
					path: '/member/'+val.platform_user_id,
				});
			}
		}
	}
</script>